import React from "react";

const TableShimmer = ({ colSize = 4, rowSize = 4 }) => {
  return (
    <div className="animate-pulse w-full">
      <div className="overflow-auto">
        <table className="w-full text-md text-left text-black ">
          <thead className="text-sm text-black uppercase bg-gray-50">
            <tr>
              {[...Array(colSize)].map((_, index) => (
                <th key={index} className="px-6 py-3">
                  <div className="w-full h-4 bg-gray-200"></div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {[...Array(rowSize)].map((_, rowIndex) => (
              <tr
                key={rowIndex}
                className="bg-white border-b"
              >
                {[...Array(colSize)].map((_, colIndex) => (
                  <td key={`${rowIndex}-${colIndex}`} className="px-6 py-3">
                    <div className="w-full h-6 bg-gray-200"></div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TableShimmer;
